import { useEffect } from "react";

export default function TrustPilotButton() {
  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(
        document.querySelector(".trustpilot-widget"),
        true
      );
    }
  }, []);

  return (
    <div
      style={{ marginTop: "1rem" }}
      className="trustpilot-widget"
      data-locale="en-US"
      data-template-id="56278e9abfbbba0bdcd568bc"
      data-businessunit-id="695e35f5996fbae4881423d7"
      data-style-height="52px"
      data-style-width="100%"
      data-token="f1df7bbf-3173-4569-9e86-969f88767a0d"
    >
      <a
        href="https://www.trustpilot.com/review/elifesavingmedicine.com"
        target="_blank"
        rel="noopener"
      >
        Trustpilot
      </a>
    </div>
  );
}
